import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type Props = {
	fileUrl?: string;
	projectCode?: string;
	fileId?: string;
	ragPage?: string;
};

function DataViewer(props: Props) {
	const { fileUrl, projectCode, fileId, ragPage } = props;

	const loadErr = (e: Error) => {
		console.log('Error while loading document! ', e.message);
	};

	const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
		console.log(`Document loaded with ${numPages} pages`);
	};

	// Parse ragPage to get page numbers
	const getPageNumbers = (ragPage?: string) => {
		if (!ragPage) return [1];
		
		// Simple parsing - you might need more sophisticated logic
		const pages = ragPage.split(',').map(p => parseInt(p.trim())).filter(p => !isNaN(p));
		return pages.length > 0 ? pages : [1];
	};

	const pageNumbers = getPageNumbers(ragPage);

	if (!fileUrl) {
		return <div>No file URL provided</div>;
	}

	return (
		<div>
			<Document
				file={fileUrl}
				onLoadError={loadErr}
				onLoadSuccess={onDocumentLoadSuccess}
			>
				{pageNumbers.map((pageNumber) => (
					<Page
						key={pageNumber}
						pageNumber={pageNumber}
						renderTextLayer={false}
						renderAnnotationLayer={false}
					/>
				))}
			</Document>
		</div>
	);
}

export default DataViewer;

